module.exports = __webpack_public_path__ + "img/template5.50fc084f.png";